import { Link } from 'react-router-dom';
import { XCircle } from 'lucide-react';
import { Button } from '../components/ui/button';

export default function PaymentCancelPage() {
    return (
        <div className="min-h-[70vh] flex items-center justify-center px-4" data-testid="payment-cancel-page">
            <div className="max-w-md w-full text-center bg-white rounded-2xl border border-slate-100 shadow-sm p-8">
                <div className="w-16 h-16 rounded-full bg-red-100 flex items-center justify-center mx-auto mb-5">
                    <XCircle className="w-9 h-9 text-red-600" />
                </div>
                <h1 className="text-2xl font-bold text-slate-900 mb-2">Payment cancelled</h1>
                <p className="text-slate-600 mb-6">
                    Your payment was not completed. You can use the payment link from your email again at any
                    time, or contact us if you need a hand.
                </p>
                <Button asChild variant="outline" className="rounded-full px-6">
                    <Link to="/contact" data-testid="payment-cancel-contact-btn">Contact Us</Link>
                </Button>
            </div>
        </div>
    );
}
